import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function FeedModal({ item, onClose }) {
  useEffect(() => {
    const onKey = e => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '800px', width: '100%', position: 'relative' }}>
        <button
          onClick={onClose}
          className="modal-close-btn"
          aria-label="Close"
        >
          &times;
        </button>
        <iframe
          src={item.embedUrl}
          style={{ width: '100%', height: '400px', border: 'none' }}
          allowFullScreen
          title={item.title}
        />
        <div style={{ padding: '16px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600' }}>{item.title}</h2>
          <p style={{ fontSize: '12px', color: '#666', textTransform: 'uppercase' }}>{item.source}</p>
        </div>
      </div>
    </div>,
    document.body
  );
}
